export default __webpack_public_path__ + "static/media/guide-to-mutual-funds.3f218188.png";